import type {
  DataverseBot,
  DataverseTool,
} from "@p0security/shared/integrations/resources/copilot-studio/types";
import type {
  AIAgent,
  AIConnector,
} from "@p0security/shared/types/ai-inventory";

export const toCopilotStudioAgent = (
  bot: DataverseBot,
  environment: { id: string; label: string }
): AIAgent => ({
  platform: "copilot-studio",
  data: bot,
  environmentId: environment.id,
  environmentLabel: environment.label,
});

export const toCopilotStudioConnector = (tool: DataverseTool): AIConnector => ({
  platform: "copilot-studio",
  data: tool,
});
